<template>
    <the-form-layout no-footer :init-method="getLoginConfig">
        <template #default="{ data }">
            <isc-form-item label="Logo">
                <the-upload-logo v-model="data.logo" config-type="loginPage" />
            </isc-form-item>

            <isc-form-item label="背景图片">
                <the-background-item
                    v-if="data.background"
                    removable
                    class="mb12"
                    :background="data.background"
                    @remove="onRemove(data)"
                />
                <the-upload-background config-type="loginPage" @success="(pic) => onSuccess(data, pic)" />
            </isc-form-item>
        </template>
    </the-form-layout>
</template>

<script>
import { showError } from '../../../../../utils/message';
import TheFormLayout from '../components/the-form-layout';
import { getLoginConfig, removeLoginBackground } from './service';
import TheUploadLogo from '@/components/desk-header/components/configs/components/the-upload-logo';
import TheUploadBackground from '@/components/desk-header/components/configs/components/the-upload-background';
import TheBackgroundItem from '@/components/desk-header/components/configs/components/the-background-item';

export default {
    name: 'LoginConfig',

    components: {
        TheBackgroundItem,
        TheUploadBackground,
        TheUploadLogo,
        TheFormLayout
    },

    data() {
        return {
            getLoginConfig
        };
    },

    methods: {
        async onRemove(form) {
            try {
                await removeLoginBackground(form.backgroundId);
            } catch (err) {
                return showError(err);
            }

            form.background = null;
        },

        /**
         * @param form
         * @param picture {DesktopPicture}
         */
        onSuccess(form, picture) {
            form.backgroundId = picture.id;
            form.background = picture.pictureUrl;
        }
    }
};
</script>

<style lang="scss" scoped></style>
